<template>
  <modal
    :ignoreBackdropClick="true"
    :show.sync="shown"
    v-if="!!currentOrder"
    headerClasses="justify-content-center pt-1 pb-2"
   :modalClasses="showWhere2Map ? 'where2-map tracking-section modal-dialog-centered modal-dialog-scrollable' : 'tracking-section modal-dialog-centered modal-dialog-scrollable'"
    @close="onClosed"
  >
    <div slot="header">
      <p class="font-weight-600 text-center mb-0 mt-3">
        {{ $t("text.order_status") }}
      </p>
      <p class="text-center mb-0">
        {{
          $t("text.last_update", {
            date_time: $moment(getLastStatus.last_update).format("HH:mm"),
          })
        }}
      </p>
    </div>
    <iframe
      v-if="showWhere2Map"
      :src="currentOrder.orderWhere2.drop.tracking_url"
    />
    <order-status v-else :order="currentOrder" :show-header="false"  />
  </modal>
</template>
<script>
import { helpers, enumHelper } from "@/utilities";
import { Modal } from "@/components";
import OrderStatus from "../components/OrderStatus";
export default {
  name: "order-view-status-modal",
  components: {
    Modal,
    "order-status": OrderStatus,
  },
  props: {
    order: Object,
  },
  computed: {
    getLastStatus() {
      return helpers.getLastOrderStatus(this.currentOrder.orderStatusHistory[0]);
    },
    getStatusImage() {
      if (this.currentOrder.order_status == enumHelper.orderStatus.COMPLETED)
        return "/img/tracking/COMPLETED.svg";
      if (this.currentOrder.order_status >= enumHelper.orderStatus.REJECTED)
        return "/img/tracking/REJECTED.svg";
      return `/img/tracking/${helpers.getKeyByValue(
        enumHelper.orderType,
        this.currentOrder.order_type
      )}_${helpers.getKeyByValue(
        enumHelper.orderStatus,
        this.currentOrder.order_status
      )}.svg`;
    },
    showWhere2Map(){
      return this.currentOrder.where2_enabled &&
        this.currentOrder.order_status == enumHelper.orderStatus.DELIVERY &&
        this.currentOrder.orderWhere2 &&
        this.currentOrder.orderWhere2.drop.status != 4 &&
        this.currentOrder.orderWhere2.pickup.status != 4
    }
  },
  data() {
    return {
      shown: false,
      currentOrder: null,
      interval: null,
      enumHelper
    };
  },
  methods: {
    refreshLiveOrder() {
      if (
        this.order ||
        (this.currentOrder &&
        this.currentOrder.order_status < enumHelper.orderStatus.REJECTED)
      ) {
        let params = {
          order_id: this.order.id,
        };
        this.fetchTrackingOrder(params)
          .then((response) => {
            if (response.data && response.data.id) {
              this.currentOrder = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    openModal() {
      // clone the object order to currentOrder and show the modal
      this.currentOrder = JSON.parse(JSON.stringify(this.order));
      this.shown = true;
      this.interval = setInterval(this.refreshLiveOrder, 10000) // 10 seconds
    },
    onClosed(){
      clearInterval(this.interval)
    }
  },
};
</script>
